<script setup lang="ts">
defineProps<{ footerMenuItems: NavMenuItem[] }>();
</script>

<template>
  <div id="site-footer" class="dark">
    <div class="container py-6 grid lg:grid-cols-3 gap-6">
      <SiteFooterPartners />
      <UNavigationMenu :items="footerMenuItems" label-key="title" orientation="vertical" variant="link" class="-mx-2.5" />
      <div class="space-y-3 lg:order-first">
        <SvgLogoTcgf class="h-16 w-auto" />
        <SiteFooterCopyright class="text-sm text-muted" />
      </div>
    </div>
  </div>
</template>
